import React, { useMemo, useCallback } from 'react';
import Accordion from 'components/Accordion';
import useLocation from 'hooks/Meteorology/Agro/WaterBalanceCulture/DetailedView/useLocation';
import useDeleteLocation from 'hooks/Meteorology/Agro/useDeleteLocation';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';
import Snackbar from 'components/DesignSystem/Snackbar';
import ConfirmationButton from 'components/ConfirmationButton';
import useSearchFilter from 'hooks/useSearchFilter';
import Searcher from 'components/DesignSystem/Searcher';
import RadioButton from 'components/DesignSystem/RadioButton';

export default function Location() {
  const { availableLocations, selectedLocation, setLocation } = useLocation();
  const closeAccordion = useMemo(() => buildAccordionClickFunction('location-accordion'), []);
  const setLocationAndClose = useCallback((newLocation : number) => () => {
    setLocation(newLocation);
    closeAccordion();
  }, [setLocation, closeAccordion]);
  const { searchTerm, onSearchChange, searchIncludes } = useSearchFilter();
  const filteredLocations = availableLocations?.filter((loc) => searchIncludes(loc.name));

  const { deleteLocation } = useDeleteLocation();

  return (
    <Accordion.Item eventKey="location" id="location-accordion">
      <Accordion.Header>Local</Accordion.Header>
      <Accordion.Body>
        {availableLocations.length === 0 && (
          <Snackbar>
            Nenhum local disponível para o grupo selecionado.
          </Snackbar>
        )}
        {availableLocations.length > 0 && (
          <>
            <Searcher
              value={searchTerm}
              onChange={onSearchChange}
              className="mb-2"
            />
            {filteredLocations.map((location) => (
              <div
                id={`location-checkbox-${location.id}`}
                className="d-flex justify-content-between align-items-center"
                key={location.id}
              >
                <RadioButton
                  label={location.name}
                  checked={location.id === selectedLocation}
                  onChange={setLocationAndClose(location.id)}
                />
                <ConfirmationButton
                  id={`delete-location-${location.id}`}
                  type="tertiary"
                  onClick={() => deleteLocation(location.id)}
                  icon="trash"
                  confirmationBody={(
                    <p>
                      Tem certeza que deseja excluir o local
                      {' '}
                      <strong>{location.name}</strong>
                      ?
                    </p>
                  )}
                />
              </div>
            ))}
          </>
        )}
      </Accordion.Body>
    </Accordion.Item>
  );
}
